import type { CalendarRef, CalendarSelectOption } from '../../../../../../../../../common/types';

export const formatOptions = (calendarRefs: CalendarRef[]) =>
	calendarRefs.map<CalendarSelectOption>(({ name, id, ...rest }) => ({
		label: name,
		value: id,
		isDefaultOption: rest.default,
	}));
